/**
 * 搜索头
 */
export const searchHeaderOptions = [
  {
    field: "id",
    label: "申请ID",
    type: "input",
    iw: 160,
    props: {
      placeholder: "请输入ID"
    }
  },
  {
    field: "company_id",
    label: "企业名称",
    type: "select-data-search",
    defaultValue: null,
    iw: 160,
    props: {
      placeholder: "请输入企业名称"
    },
    options: []
  },
  {
    field: ["start_time", "end_time"],
    iw: 324,
    label: "申请时间",
    type: "dateRange",
    props: {
      dateFormat: "YYYY/MM/DD"
    }
  }
];
